import { DOCUMENT_TYPES } from '~constants/common';

import { useToast } from '~libs/toast';

import { useDocumentBatchGeneration } from '~main/components/document-batch-jobs/useDocumentBatchGeneration';

/**
 * Starts Print to Sign (TAV-3313) for one or more budgets: one document job per budget, generated by
 * Document Engine like Export To PDF. The PDFs arrive in the document batches menu, and a copy of each
 * is kept for the Print to Sign viewer once its job completes.
 */
export const usePrintBudgetsToSign = () => {
  const { generateSeparate, isGenerating } = useDocumentBatchGeneration();
  const { showToast } = useToast();

  const printToSign = async (budgetIds: string[]): Promise<boolean> => {
    if (!budgetIds.length) return false;
    try {
      await generateSeparate(DOCUMENT_TYPES.SAH_BUDGET.PRINT_TO_SIGN, budgetIds).unwrap();
      showToast(
        'success',
        budgetIds.length === 1 ? 'Print to Sign started' : `Print to Sign started for ${budgetIds.length} budgets`,
      );
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to start Print to Sign';
      showToast('danger', message);
      return false;
    }
  };

  return { printToSign, isPrinting: isGenerating };
};
